"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIPTIONS_ADD_TO_BAG = void 0;
const SUBSCRIPTIONS_ADD_TO_BAG = exports.SUBSCRIPTIONS_ADD_TO_BAG = 'product-info-dialog-subscriptions-add-to-bag';